import React from 'react';
import { IconButton as MuiIconButton, IconButtonProps } from '@mui/material';

const IconButton: React.FC<IconButtonProps> = (props) => {
  return <MuiIconButton {...props} />;
};

export default React.memo(IconButton);
